import { ChangeDetectionStrategy, Component, OnInit, inject } from "@angular/core";
import { GlobalRunningJobsService } from "src/app/services/running-jobs/global-running-jobs.service";
import { Monitoring } from "src/app/utils/monitoring";
import { isStageLocalhost } from "src/app/utils/storebrand-staging";
import { ButtonModule } from "@storeblocks/button-ng";
import { RouterLink } from "@angular/router";
import { FmsPipe } from "src/app/modules/shared/pipes/fms.pipe";

@Component({
  selector: "app-page-not-found",
  templateUrl: "./pagenotfound.component.html",
  styleUrls: ["./pagenotfound.component.scss"],
  standalone: true,
  imports: [ButtonModule, RouterLink, FmsPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageNotFoundComponent implements OnInit {
  private readonly globalRunningJobsService = inject(GlobalRunningJobsService);

  constructor() {
    this.globalRunningJobsService.forceStop();
  }

  ngOnInit(): void {
    const location = window.location;
    Monitoring.info(`404 on location: ${location}`, { ignore: isStageLocalhost() });
  }
}
